import { getAscendantCodes } from "@l2r-front/l2r-utils"

import { useRoadsideTypes } from "../queries/useRoadsideTypes"

export function useRoadsideAscendantCodes(code) {
    const { data: roadsideTypes } = useRoadsideTypes()

    return getAscendantCodes(code, roadsideTypes)
}